import { useTranslation } from "next-i18next";

import { IconNavigationLocationPinOutline } from "@/assets/icons/figma/IconNavigationLocationPinOutline";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemRow } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemRow";
import { useProductDeliveryProductPickupAddress } from "@/features/product-delivery-options/hooks/useProductDeliveryProductPickupAddress";
import { showModal } from "@/ui/Modal2";

export const ProductDeliveryOptionItemPickup = ({
  product,
}: ProductDeliveryOptionItemProps) => {
  const { t } = useTranslation();
  const { address } = useProductDeliveryProductPickupAddress(product);

  const handleViewItemClick = () => {
    showModal("pdp-details-modal", {
      title: t("shipping-options:product-shipping-option-self-pickup-title"),
      text: t("shipping-options:product-shipping-option-self-pickup-body"),
    });
  };

  return (
    <ProductDeliveryOptionItemRow
      method="pickup"
      icon={
        <IconNavigationLocationPinOutline className="size-6 shrink-0 text-brand-500" />
      }
      title={t("pdp:pdp-usp-shipping-title-pickup")}
      subtitle={address}
      priceLabel={t("common:common-free")}
      isFree
      onInfoClick={handleViewItemClick}
    />
  );
};
